import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { subscribeWithSelector } from "zustand/middleware";
import sqliteStorage from "./sqliteStorage";

const DEFAULTS = {
  posConfig: null,
  posType: null,
  saleTypeData: null,
  orderTimeDetails: null,
};

const usePOSConfigStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        ...DEFAULTS,
        _hydrated: false,

        // Actions — no manual localStorage writes; Zustand persist + sqliteStorage handles it.
        setPosConfig: (config) => {
          set({ posConfig: config });
        },

        setPosType: (posType) => {
          set({ posType });
        },

        setSaleTypeData: (data) => {
          set({ saleTypeData: data });
          if (window.electronAPI?.sync?.setOrderSyncConfig && data?.cwrSaletype) {
            window.electronAPI.sync.setOrderSyncConfig({
              saleTypeId: data.cwrSaletype.cwrSaletypeId,
              taxIncludeFlag: data.customer?.istaxincluded || "Y",
            }).catch(() => {});
          }
        },

        setOrderTimeDetails: (details) => {
          set({ orderTimeDetails: details });
        },

        getCustomerFromSaleType: () => {
          return get().saleTypeData?.customer || null;
        },

        isTaxIncludedFromSaleType: () => {
          return get().saleTypeData?.customer?.istaxincluded === "Y";
        },

        getDocumentSequence: () => {
          return get().posConfig?.documentSequence || 0;
        },

        getPosSaleTypes: () => {
          return get().posConfig?.posSaleTypes || [];
        },

        getOrderType: () => {
          return get().orderTimeDetails?.orderType || null;
        },

        clearAll: () => {
          set({ posConfig: null, posType: null, saleTypeData: null, orderTimeDetails: null });
        },
      }),
      {
        name: "posConfigStore",
        storage: createJSONStorage(() => sqliteStorage),
        skipHydration: true,
        partialize: (state) => ({
          posConfig: state.posConfig,
          posType: state.posType,
          saleTypeData: state.saleTypeData,
          orderTimeDetails: state.orderTimeDetails,
        }),
        merge: (persisted, current) => ({
          ...current,
          ...DEFAULTS,
          ...(persisted || {}),
          _hydrated: true,
        }),
      }
    )
  )
);

export default usePOSConfigStore;
